import { useEditNicheModalModel } from './edit-niche-modal.model'
import type { IEditNicheModal } from './edit-niche-modal.types'
import { EditNicheModalView } from './edit-niche-modal.view'

export const EditNicheModal = ({ handleClose, isOpen }: IEditNicheModal) => {
  const editNicheModalModel = useEditNicheModalModel()
  return <EditNicheModalView {...editNicheModalModel} handleClose={handleClose} isOpen={isOpen} />
}
